import { ReactNode } from 'react';

import { Typography, TypographyProps } from '@mui/material';
import Grid, { GridProps } from '@mui/material/Grid';

interface DialogFormSectionProps {
  title?: string;
  children: ReactNode;
  titleProps?: TypographyProps;
  gridProps?: GridProps;
}

const defaultTitleProps: TypographyProps = {
  variant: 'h6',
};

export function DialogFormSection({
  title,
  children,
  titleProps = defaultTitleProps,
  gridProps,
}: DialogFormSectionProps) {
  return (
    <Grid container rowGap={2} columnSpacing={2} justifyContent="center" alignItems="flex-start" py={2} {...gridProps}>
      {title && (
        <Grid size={12}>
          <Typography {...titleProps}>{title}</Typography>
        </Grid>
      )}
      {children}
    </Grid>
  );
}

export default DialogFormSection;
